// @flow

import * as React from 'react';

import Duration from 'app/components/shared/Duration';

type Props = {
  label: string,
  from: string,
  to: ?string
};

export default class WaitTime extends React.PureComponent<Props> {
  render() {
    const duration: {
      from: string,
      to?: string
    } = {
      from: this.props.from
    };

    // Our relative time class doesn't handle "null" values for the to key so we
    // need to conditionally add it, rather than just passing through
    // props.duration wholesale
    if (this.props.to) {
      duration.to = this.props.to;
    }

    return (
      <div className="pl2 dark-gray">
        <i className="fa fa-clock-o mr1" />
        <span>
          {`${this.props.label} `}
          <Duration.Short {...duration} />
        </span>
      </div>
    );
  }
}
